import { useCallback } from "react";
import { useAvailableDates } from "api/hooks";
import { format, isValid } from "date-fns";
import { uk } from "date-fns/locale/uk";
import { useSearchParams } from "react-router-dom";
import { Button, Typography } from "theme";

import { Box, CircularProgress, Grid2 } from "@mui/material";

const NoAvailableSlots = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isFetching, availableDates } = useAvailableDates({
    hallId: searchParams.get("h"),
  });

  const onNextDateClick = useCallback(
    (date: Date) => {
      setSearchParams((prev) => {
        prev.set("d", date ? format(date, "yyyy-MM-dd") : "");

        return prev;
      });
    },
    [setSearchParams],
  );

  if (isFetching) {
    return (
      <Grid2 mt={2} container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    );
  }

  const availableDate = new Date(
    availableDates?.[1]?.availableDate || availableDates?.[0]?.availableDate,
  );

  return (
    <Grid2 mt={2.5} container flexDirection="column" alignItems="center" rowGap={1.25}>
      <Typography variant="body1" textTransform="uppercase" color="primary" weight="semiBold">
        На цей день немає вільних місць
      </Typography>
      {isValid(availableDate) && (
        <>
          <Box>
            <Typography variant="body1" color="placeholder" weight="semiBold">
              Найближча доступна дата:
            </Typography>
            <Typography variant="body1" color="placeholder" weight="semiBold" textAlign="center">
              {format(availableDate, "dd MMMM", {
                locale: uk,
              })}
            </Typography>
          </Box>
          <Button onClick={() => onNextDateClick(availableDate)}>Відкрити найближчу дату</Button>
        </>
      )}
    </Grid2>
  );
};

export default NoAvailableSlots;
